
<mat-card class="mb-3">

<ng-container *ngIf="spaBasket">

            <div class="basket-total-bar d-flex justify-content-between">
                <div>Your treatments ({{spaBasket.items.length}})</div>
                <div class="text-align: right">{{spaBasket.total_cost / 100 | currency : 'GBP'}}</div>
            </div>

            <div class="basket-item mb-1" *ngFor="let item of spaBasket.items">
                <p class="mb-1" *ngIf="item.offering_id !== '67911f1e7c63a972c40c34e3'">{{item.offering_name}} {{item.total_cost / 100 | currency : 'GBP'}}</p>
                <p class="mb-1" *ngIf="item.offering_id === '67911f1e7c63a972c40c34e3'">{{item.package_items[0].offering_name}} {{item.total_cost / 100 | currency : 'GBP'}}</p>
                <p class="mb-1">{{item.time | date: 'dd/MM/yyyy @ HH:mm'}}</p>
                <p class="mb-1" *ngFor="let g of item.guests">Guest name: {{g.name}}</p>
                <a *ngIf="allowDelete && item.offering_id !== '67911f1e7c63a972c40c34e3'" class="hover" (click)="removeItem(item)">
                    <i class="fa fa-trash"></i>
                </a>
            </div>

</ng-container>
<ng-container *ngIf="!spaBasket">
    <div class="basket-total-bar d-flex justify-content-between">
        <div>Your treatments (0)</div>
        <div class="text-align: right">£0.00</div>
    </div>
</ng-container>
</mat-card>
